import React from "react";
import "../CSS/ApplicationModal.css";


const ApplicantsModal = ({ opportunity, onClose }) => {
  if (!opportunity) return null;

  // Mock applicants data (In production, fetch via API using opportunity.id)
  const applicants = opportunity.applicantsList || [
    {
      id: 101,
      name: "John Doe",
      institution: "Kenyatta University",
      county: "Nairobi",
      appliedTimeAgo: "2 hours ago",
      cvUrl: "https://example.com/cv/john-doe.pdf"
    },
    {
      id: 102,
      name: "Jane Wanjiku",
      institution: "University of Nairobi",
      county: "Kiambu",
      appliedTimeAgo: "1 day ago",
      cvUrl: "https://example.com/cv/jane-wanjiku.pdf"
    },
    {
      id: 103,
      name: "Brian Omondi",
      institution: "Jomo Kenyatta University (JKUAT)",
      county: "Kisumu",
      appliedTimeAgo: "2 days ago",
      cvUrl: "https://example.com/cv/brian-omondi.pdf"
    }
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-container applicants-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* MODAL HEADER */}
        <div className="modal-header">
          <div>
            <span className="small-green-label">APPLICANTS REVIEW</span>
            <h2>{opportunity.jobTitle}</h2>
            <p className="modal-subtitle">
              🏢 {opportunity.organizationName} • 📍 {opportunity.county}
            </p>
          </div>
          <button className="close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* MODAL BODY */}
        <div className="modal-body">
          <div className="modal-stats-bar">
            <span>
              Total Applicants: <b>{applicants.length}</b>
            </span>
            <span>
              Openings: <b>{opportunity.openings}</b>
            </span>
          </div>

          {applicants.length === 0 ? (
            <div className="empty-applicants">
              <div className="empty-icon">📩</div>
              <p>No applications submitted for this opportunity yet.</p>
            </div>
          ) : (
            <div className="applicants-list">
              {applicants.map((applicant) => (
                <div className="applicant-card" key={applicant.id}>
                  <div className="applicant-main-info">
                    <div className="applicant-avatar">
                      {applicant.name
                        .split(" ")
                        .map((n) => n[0])
                        .join("")}
                    </div>
                    <div>
                      <h4 className="applicant-name">{applicant.name}</h4>
                      <p className="applicant-institution">
                        🎓 {applicant.institution}
                      </p>
                    </div>
                  </div>

                  <div className="applicant-meta-grid">
                    <div className="meta-item">
                      <small>COUNTY LOCATION</small>
                      <span>📍 {applicant.county}</span>
                    </div>

                    <div className="meta-item">
                      <small>APPLICATION TIME</small>
                      <span>⏱ {applicant.appliedTimeAgo}</span>
                    </div>

                    <div className="meta-item action-item">
                      <small>CURRICULUM VITAE</small>
                      <a
                        href={applicant.cvUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="view-cv-btn"
                      >
                        📄 View / Download CV
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* MODAL FOOTER */}
        <div className="modal-footer">
          <button className="modal-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicantsModal;